import gsap from 'gsap'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

export interface MenuAccordionCollapseProps {
  isActive?: boolean
}

const MenuAccordionCollapse: React.FC<
  React.HTMLAttributes<HTMLDivElement> & MenuAccordionCollapseProps
> = ({ children, className, isActive }) => {
  const divRef = useRef<HTMLDivElement>(null)
  const tlRef = useRef<gsap.core.Timeline>()
  const [collapsed, setCollapsed] = useState(!isActive)

  useEffect(() => {
    // create timeline for animating accordion content
    const tl = gsap.timeline({
      reversed: true,
      paused: true,
      onReverseComplete() {
        setCollapsed(true)
      },
    })
    tl.set(divRef.current, { display: 'block' })
    tl.fromTo(
      divRef.current,
      { height: 0, opacity: 0 },
      { height: 'auto', opacity: 1, duration: 0.35 },
    )
    tlRef.current = tl
  }, [])

  useEffect(() => {
    if (!divRef.current || !tlRef.current) return
    if (!isActive) {
      tlRef.current.reverse()
      setCollapsed(false)
    } else {
      tlRef.current.play()
    }
  }, [isActive])

  return (
    <div className={className} ref={divRef}>
      {isActive || !collapsed ? children : null}
    </div>
  )
}

const StyledMenuAccordionCollapse = styled(MenuAccordionCollapse)`
  overflow: hidden;
  display: none;
  height: 0;
  opacity: 0;
`

export { StyledMenuAccordionCollapse as MenuAccordionCollapse }
